/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export default class Controller {
  constructor(props) {
    this.setup(props);
  }

  setup = props => {
    this.scene = props.scene;
    this.camera = props.camera;
    this.canvas = props.canvas;
    this.debug = props.debug;

    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.canvas.addEventListener('click', this.onClick, false);
  };

  setCamera = camera => {
    this.camera = camera;
  };

  onClick = event => {
    this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
    this.mouse.y = -event.clientY / window.innerHeight * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.camera);
    let children = this.scene.children;
    children = children != undefined ? children : this.scene;
    let intersects = this.raycaster.intersectObjects(children, true);
    if (intersects.length) {
      let object = intersects[0].object;
      object.traverseAncestors(parent => {
        parent.dispatchEvent({
          type: 'click',
          object: parent,
        });
      });
      event.preventDefault();
    }
  };
}



// WEBPACK FOOTER //
// ./src/hud/Controller.js